import {
  BadgePlus,
  BugIcon,
  CircleHelp,
  CpuIcon,
  PlusCircleIcon,
} from "lucide-react";

import { Tables } from "@kit/supabase/database";
import { Badge } from "@kit/ui/badge";
import { cn } from "@kit/ui/utils";
import { Trans } from "@kit/ui/trans";

export function IssueTypeBadge(props: {
  type: Tables<"issues">["type"];
  className?: string;
}) {
  const type = props.type;

  let Icon: React.ReactElement | null;
  let text = "";

  switch (type) {
    case "improvement":
      text = "roadmap:improvement";
      Icon = <PlusCircleIcon className={"mr-1 h-3 w-3 text-green-600"} />;
      break;
    case "bug":
      text = "roadmap:bug";
      Icon = <BugIcon className={"text-destructive mr-1 h-3 w-3"} />;
      break;
    case "feature":
      text = "roadmap:feature";
      Icon = <BadgePlus className={"mr-1 h-3 w-3 text-blue-500"} />;
      break;
    case "question":
      text = "roadmap:question";
      Icon = <CircleHelp className={"text-yellow mr-1 h-3 w-3"} />;
      break;
    default:
      text = "roadmap:task";
      Icon = <CpuIcon className={"mr-1 h-3 w-3 text-orange-400"} />;
  }

  return (
    <Badge
      className={cn("flex gap-1 px-1.5", props.className)}
      variant={"outline"}
    >
      {Icon}
      <span>
        <Trans i18nKey={text} defaults={text} />
      </span>
    </Badge>
  );
}
